import { Injectable, FactoryProvider, Type } from '@angular/core';
import { Subject } from "rxjs";
import { QuestionKind } from '../../flow/models/flow.model';
import { Question } from '../../common/models/flow.dto';
import { TEXTBOX_CONTROLLERS } from '../../form-controls/components/textbox/textbox.component';
import { DROPDOWN_CONTROLLERS } from "../../form-controls/components/dropdown/dropdown.component";
import { FLOW_DATA_TABLE_CONTROLLERS } from '../../form-controls/components/data-table/flow-data-table.component';


@Injectable()
export class StateBuilderService {

    private dragData: any = null;
    showLoader: boolean = false;

    readonly questionsChanged$ = new Subject<void>();

    getConfigurationType(type: QuestionKind): ConfigurationType {

        let configurationType: ConfigurationType;
        switch (type) {
            case QuestionKind.MultiselectCheckbox:
                configurationType = { display: "empty", data: "multiselect" };
                break;
            case QuestionKind.Dropdown:
                configurationType = { display: "multiselect", data: "multiselect", controllers: DROPDOWN_CONTROLLERS };
                break;
            case QuestionKind.Textbox:
                configurationType = { display: "textual", data: "empty", controllers: TEXTBOX_CONTROLLERS };
                break;
            case QuestionKind.Checkbox:
                configurationType = { display: "boolean", data: "empty" };
                break;
            case QuestionKind.Radio:
                configurationType = { display: "radio", data: "radio" };
                break;
            case QuestionKind.ButtonLink:
                configurationType = { display: "buttonlink", data: "buttonlink" };
                break;
            case QuestionKind.PdfGenerator:
                configurationType = { display: "pdfgenerator", data: "pdfgenerator" };
                break;
            case QuestionKind.ESignature:
                configurationType = { display: "esignature", data: "empty" };
                break;
            case QuestionKind.FileUpload:
                configurationType = { display: "fileupload", data: "fileupload" };
                break;
            case QuestionKind.DataQueryButton:
                configurationType = { display: "dataquerybutton", data: "dataquerybutton" };
                break;
            case QuestionKind.ReportPdfView:
                configurationType = { display: "empty", data: "reportpdfviewer" }
                break;
            case QuestionKind.ReportTemplateEditor:
                configurationType = { display: "empty", data: "reporttemplateeditor" }
                break;
            case QuestionKind.FlowDataTable:
                configurationType = { display: 'empty', data: 'datatable', controllers: FLOW_DATA_TABLE_CONTROLLERS };
                break;
            case QuestionKind.PaymentCheckout:
                configurationType = { display: "empty", data: "paymentCheckout" };
                break;
            case QuestionKind.PaymentResponse:
                configurationType = { display: "empty", data: "paymentresponse" };
                break;
            case QuestionKind.CasingPlanGrid:
                configurationType = { display: "empty", data: "casingPlanGrid" };
                break;
            case QuestionKind.NewCasingPlan:
                configurationType = { display: "empty", data: "casingPlan" };
                break;
            case QuestionKind.RouteControl:
            case QuestionKind.MapControl:
                configurationType = { display: "empty", data: "mapControl" };
                break;
            case QuestionKind.AreaOfReviewMap:
                configurationType = { display: "empty", data: "areaofreviewmapcontrol" }; 
                break;
            case QuestionKind.PdfViewer:
                configurationType = { display: "empty", data: "flowpdfviewer" };
                break;
            case QuestionKind.DatePicker:
                configurationType = { display: "empty", data: "datepicker" };
                break;
            case QuestionKind.ListEntry:
                configurationType = { display: "listentry", data: "empty" };
                break;
            case QuestionKind.CasingPlanSchematic:
                configurationType = { display: "casingplanschematic", data: "casingplanschematic" };
                break;
            case QuestionKind.FileParser:
                configurationType = { display: "empty", data: "fileparser" };
                break;
            case QuestionKind.BulkWellTransferParser:
                configurationType = { display: "empty", data: "bulkwelltransferparser" };
                break;
            default:
                configurationType = { display: "empty", data: "empty" };
                break;
        }

        return configurationType;
    }

    hasData(question: Question): boolean {
        return question.type !== QuestionKind.ButtonLink;
    }



	private innerRowDropListIds: string[] = [];

	setInnerRowDropListIds(ids: string[]): void {
		this.innerRowDropListIds = ids;
	}

	getInnerRowDropListIds(): string[] {
		return this.innerRowDropListIds;
	}

	setDragData(data: any) {
        this.dragData = data;
    }

	getDragData() {
        return this.dragData;
    }

    clearDragData() {
        this.dragData = null;
    }
}

export interface ConfigurationType {
    data: string;
    display: string;
    controllers?: (FactoryProvider & { settings?: Type<any>[] })[];
}